module.exports = __webpack_public_path__ + "static/media/newsuccess.bc246180.png";